(() => {
  'use strict';

  class PumpkinPdpReviewsListElement extends HTMLElement {
    connectedCallback() {
      this.pumpkinToggleBtn = this.querySelector('.pumpkin_pdp_reviews_list__toggle');

      if (!this.pumpkinToggleBtn) return;

      this.handlePumpkinToggle = this.handlePumpkinToggle.bind(this);
      this.pumpkinToggleBtn.addEventListener('click', this.handlePumpkinToggle);
    }

    disconnectedCallback() {
      this.pumpkinToggleBtn?.removeEventListener('click', this.handlePumpkinToggle);
    }

    handlePumpkinToggle() {
      this.setPumpkinExpanded(!this.classList.contains('is-expanded'));
    }

    setPumpkinExpanded(expanded) {
      this.classList.toggle('is-expanded', expanded);
      this.pumpkinToggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      const pumpkinLabelMore = this.pumpkinToggleBtn.dataset.labelMore;
      const pumpkinLabelLess = this.pumpkinToggleBtn.dataset.labelLess;

      this.pumpkinToggleBtn.textContent = expanded ? pumpkinLabelLess : pumpkinLabelMore;
    }
  }

  if (!customElements.get('pumpkin-pdp-reviews-list')) {
    customElements.define('pumpkin-pdp-reviews-list', PumpkinPdpReviewsListElement);
  }
})();